import AuthService from "./authservice";

const RenderOnAuthenticated = ({ children }) => (AuthService.isLoggedIn()) ? children : null;

export default RenderOnAuthenticated
